module.exports = "/_next/static/images/9b46f70ea6dadb11e76ad193d5132c00-phone-with-app-open-and-card@1x-md.jpg.webp";